import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=04a81d3e&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04a81d3e')) {
      api.createRecord('04a81d3e', component.options)
    } else {
      api.reload('04a81d3e', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=04a81d3e&", function () {
      api.rerender('04a81d3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eg3tNOmVeG0q/JS/imageCarousel.vue"
export default component.exports